export class PulumiConfigurationsRequest {
    'filters';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "PulumiConfigurationsFilterConditions",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PulumiConfigurationsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
